import React, { useContext, useEffect, useState } from "react";
import dayjs from "dayjs";

import css from "./Today.module.css";
import { UserContext } from "../../Context/UserContext";
import { Head } from "../../Utils/Head";
import { updateUserFirebase } from "../../Utils/firebaseUser";
import { valuesQuestionarePt } from "../../Utils/valuesQuestionare";
import { newId } from "../../Utils/newId";

export const Diary = () => {
  const { userData, setUserData } = useContext(UserContext);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [errorAlert, setErrorAlert] = useState("");
  const [errorDone, setErrorDone] = useState("");
  const [actsToday, setActsToday] = useState([]);
  const [mood, setMood] = useState(false);

  useEffect(() => {
    userData &&
      userData.diary &&
      userData.diary[dayjs().format("YYMMDD")] &&
      setActsToday([
        ...userData.diary[dayjs().format("YYMMDD")].filter((a) => !a.done),
      ]);
  }, [userData]);

  function handleDeleteAct(a) {
    let updatedList = [...userData.diary[a.date]];
    updatedList = updatedList.filter((e) => e.id !== a.id);
    userData.diary[a.date] = [...updatedList];

    a.date === dayjs().format("YYMMDD") && setActsToday(updatedList);

    setUserData(userData);
    updateUserFirebase(userData);
  }

  function handleValidationDone(a) {
    let formIsValid = true;
    if (!mood) {
      formIsValid = false;
      setErrorDone(a.id);
    } else if (mood && mood.slice(1) !== a.id) {
      formIsValid = false;
      setErrorDone(a.id);
    } else {
      setErrorAlert("");
    }
    return formIsValid;
  }

  function handleActDone(a) {
    let updatedList = [...userData.diary[a.date]];

    updatedList.forEach((element) => {
      if (element.id === a.id) {
        element.mood = mood[0];
        element.done = true;
      }
    });
    userData.diary[a.date] = [...updatedList];

    a.date === dayjs().format("YYMMDD") &&
      setActsToday(updatedList.filter((a) => !a.done));

    setUserData(userData);
    updateUserFirebase(userData);
  }

  if (userData && userData.diary) {
    return (
      <div className={css.container}>
        <Head title="Today" description={"User - Mairini"} />
        <section className={css.sectionTodayDiary}>
          <h1>Diário</h1>
          {/* <p>Filtrar</p>
          <div className={css.filter}>
            <button className="defaultButton">Não Concluídas</button>
            <button className="defaultButton">Concluídas</button>
          </div> */}

          {userData.diary && (
            <>
              {Object.values(userData.diary).map((arr) =>
                arr.map((act) => (
                  <div key={act.id} className={css.card}>
                    <div className={css.cardHead}>
                      <h4>{act.act}</h4>
                      {/* <i
                        className={`material-icons materialIcon`}
                        onClick={() => setShowDeleteModal(act)}
                      >
                        delete
                      </i> */}
                    </div>
                    <p>
                      Data:{" "}
                      {act.date[4] +
                        act.date[5] +
                        "/" +
                        act.date[2] +
                        act.date[3] +
                        "/" +
                        act.date[0] +
                        act.date[1]}
                    </p>
                    <p>Valor: {act.value}</p>

                    {dayjs().format("YYMMDD") >= act.date && (
                      <div className={css.cardMood}>
                        {act.done ||
                          (dayjs().format("YYMMDD") >= act.date && (
                            <p>Como foi a atividade?</p>
                          ))}
                        {Number(act.mood) === 1 || mood === 1 + act.id ? (
                          <i
                            className={`material-icons materialIcons ${css.cardMoodActive}`}
                            onClick={() => setMood(false)}
                          >
                            mood_bad
                          </i>
                        ) : (
                          <i
                            className={`material-icons ${css.cardUserIcon}`}
                            onClick={() => setMood(1 + act.id)}
                          >
                            mood_bad
                          </i>
                        )}

                        {Number(act.mood) === 2 || mood === 2 + act.id ? (
                          <i
                            className={`material-icons ${css.cardMoodActive}`}
                            onClick={() => setMood(false)}
                          >
                            sentiment_very_dissatisfied
                          </i>
                        ) : (
                          <i
                            className={`material-icons ${css.cardUserIcon}`}
                            onClick={() => setMood(2 + act.id)}
                          >
                            sentiment_very_dissatisfied
                          </i>
                        )}
                        {Number(act.mood) === 3 || mood === 3 + act.id ? (
                          <i
                            className={`material-icons ${css.cardMoodActive}`}
                            onClick={() => setMood(false)}
                          >
                            sentiment_satisfied
                          </i>
                        ) : (
                          <i
                            className={`material-icons ${css.cardUserIcon}`}
                            onClick={() => setMood(3 + act.id)}
                          >
                            sentiment_satisfied
                          </i>
                        )}
                        {Number(act.mood) === 4 || mood === 4 + act.id ? (
                          <i
                            className={`material-icons ${css.cardMoodActive}`}
                            onClick={() => setMood(false)}
                          >
                            sentiment_satisfied_alt
                          </i>
                        ) : (
                          <i
                            className={`material-icons ${css.cardUserIcon}`}
                            onClick={() => setMood(4 + act.id)}
                          >
                            sentiment_satisfied_alt
                          </i>
                        )}
                        {Number(act.mood) === 5 || mood === 5 + act.id ? (
                          <i
                            className={`material-icons ${css.cardMoodActive}`}
                            onClick={() => setMood(false)}
                          >
                            sentiment_very_satisfied
                          </i>
                        ) : (
                          <i
                            className={`material-icons ${css.cardUserIcon}`}
                            onClick={() => setMood(5 + act.id)}
                          >
                            sentiment_very_satisfied
                          </i>
                        )}
                      </div>
                    )}
                    {errorDone === act.id && (
                      <p className={css.error}>
                        É preciso avaliar a atividade antes de concluí-la
                      </p>
                    )}
                    {mood && mood.slice(1, mood.length) === act.id
                      ? dayjs().format("YYMMDD") >= act.date && (
                          <button
                            className="greenButton"
                            onClick={() => handleActDone(act)}
                          >
                            Concluída
                          </button>
                        )
                      : dayjs().format("YYMMDD") >= act.date && (
                          <button className={css.buttonDisabled}>
                            Concluída
                          </button>
                        )}
                  </div>
                ))
              )}
            </>
          )}

          {userData.diary && (
            <>
              {actsToday[0] &&
                actsToday.map((a) => (
                  <div className={css.card} key={a.id}>
                    <div className={css.cardHead}>
                      <h4>{a.value}</h4>
                      <i
                        className={`material-icons materialIcon`}
                        onClick={() => setShowDeleteModal(a)}
                      >
                        delete
                      </i>
                    </div>
                    <h1>{a.act}</h1>
                    {a.date === dayjs().add(1, "day").format("YYMMDD") && (
                      <h1>Hoje</h1>
                    )}
                    {a.date === dayjs().format("YYMMDD") && <h1>Hoje</h1>}
                    <div className={css.cardMood}>
                      <p>Como foi a atividade?</p>
                      {mood === 0 + a.id ? (
                        <i
                          className={`material-icons materialIcons ${css.cardMoodActive}`}
                          onClick={() => setMood(false)}
                        >
                          mood_bad
                        </i>
                      ) : (
                        <i
                          className={`material-icons ${css.cardUserIcon}`}
                          onClick={() => setMood(0 + a.id)}
                        >
                          mood_bad
                        </i>
                      )}

                      {mood === 1 + a.id ? (
                        <i
                          className={`material-icons ${css.cardMoodActive}`}
                          onClick={() => setMood(false)}
                        >
                          sentiment_very_dissatisfied
                        </i>
                      ) : (
                        <i
                          className={`material-icons ${css.cardUserIcon}`}
                          onClick={() => setMood(1 + a.id)}
                        >
                          sentiment_very_dissatisfied
                        </i>
                      )}
                      {mood === 2 + a.id ? (
                        <i
                          className={`material-icons ${css.cardMoodActive}`}
                          onClick={() => setMood(false)}
                        >
                          sentiment_satisfied
                        </i>
                      ) : (
                        <i
                          className={`material-icons ${css.cardUserIcon}`}
                          onClick={() => setMood(2 + a.id)}
                        >
                          sentiment_satisfied
                        </i>
                      )}
                      {mood === 3 + a.id ? (
                        <i
                          className={`material-icons ${css.cardMoodActive}`}
                          onClick={() => setMood(false)}
                        >
                          sentiment_satisfied_alt
                        </i>
                      ) : (
                        <i
                          className={`material-icons ${css.cardUserIcon}`}
                          onClick={() => setMood(3 + a.id)}
                        >
                          sentiment_satisfied_alt
                        </i>
                      )}
                      {mood === 4 + a.id ? (
                        <i
                          className={`material-icons ${css.cardMoodActive}`}
                          onClick={() => setMood(false)}
                        >
                          sentiment_very_satisfied
                        </i>
                      ) : (
                        <i
                          className={`material-icons ${css.cardUserIcon}`}
                          onClick={() => setMood(4 + a.id)}
                        >
                          sentiment_very_satisfied
                        </i>
                      )}
                    </div>
                    {errorDone === a.id && (
                      <p className={css.error}>
                        É preciso avaliar a atividade antes de concluí-la
                      </p>
                    )}
                    <button
                      className="greenButton"
                      onClick={() =>
                        handleValidationDone(a) && handleActDone(a)
                      }
                    >
                      Concluída
                    </button>
                  </div>
                ))}
            </>
          )}
        </section>

        {showDeleteModal && (
          <div className={css.modalContainer}>
            <div className={css.modal}>
              <header className={css.modalHeader}>
                <span
                  onClick={() => setShowDeleteModal(false)}
                  className={`material-icons ${css.materialIcon} ${css.materialButton}`}
                >
                  close
                </span>
              </header>
              <div className={css.modalBody}>
                <h4>Deletar ação: {showDeleteModal.act}</h4>

                <footer className={css.modalFooter}>
                  <button
                    className="defaultButton"
                    onClick={() => {
                      setShowDeleteModal(false);
                    }}
                  >
                    Cancelar
                  </button>
                  <button
                    className="deleteButton"
                    onClick={() => {
                      handleDeleteAct(showDeleteModal);
                      setShowDeleteModal(false);
                    }}
                  >
                    Deletar
                  </button>
                </footer>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  } else {
    return (
      <div className={css.container}>
        <section>
          <div className={css.schedule}>
            <h2>Agenda {dayjs().format("DD.MM.YY")}</h2>
            <h5>Aqui você visualiza a agenda do seu dia.</h5>
          </div>
        </section>
      </div>
    );
  }
};
